import React from 'react';

import cx from 'classnames';
import { createPortal } from 'react-dom';
import { ToggleLayer, Transition } from 'react-laag';
import { useSelector } from 'react-redux';

import Dropdown from 'components/shared/Dropdown';
import Icon from 'components/shared/Icon';
import Triangle from 'components/shared/Icon/icons/Triangle';
import { appHasChangesSelector } from 'store/unsavedChanges/selectors';
import { isAgentSelector } from 'store/user/selectors';

import { prepareAccountsLinks, useMenu, userMenuLabelMap, useTermsModal } from './functions';
import styles from './index.module.css';
import Links from './Links';

const UserMenu = () => {
  const { user } = useMenu();
  const doesAppHaveChanges = useSelector(appHasChangesSelector);
  const { modal } = useTermsModal();
  const firstLetter = user?.firstName?.[0] || 'G';
  const accountList = prepareAccountsLinks(user?.accountList || []);
  const isAgent = useSelector(isAgentSelector);

  return (
    <>
      {modal}
      <ToggleLayer
        renderLayer={({ isOpen, layerProps, close }) => (
          <Transition isOpen={isOpen}>
            {(isOpen, onTransitionEnd) =>
              createPortal(
                <div
                  ref={layerProps.ref}
                  onTransitionEnd={onTransitionEnd}
                  className="layer"
                  style={{
                    ...layerProps.style,
                    transition: 'opacity 250ms, transform 250ms',
                    transform: isOpen ? '' : 'translate(0, -10px)',
                    opacity: isOpen ? 1 : 0,
                    zIndex: 9999,
                  }}
                >
                  <Dropdown className={styles.dropdownLayout}>
                    <Links close={close} />
                  </Dropdown>
                </div>,
                document.body,
              )
            }
          </Transition>
        )}
        placement={{
          anchor: 'RIGHT_BOTTOM',
          autoAdjust: true,
          triggerOffset: 10,
        }}
        fixed
        closeOnOutsideClick
      >
        {({ triggerRef, toggle }) => {
          return (
            <button
              type="button"
              className={styles.user}
              ref={triggerRef}
              onClick={toggle}
              disabled={doesAppHaveChanges}
            >
              <div className={styles.userName}>
                {firstLetter.toUpperCase()}
                {accountList.length > 1 && !isAgent && (
                  <span className={cx(styles.accountType, styles[`accountType-${user.currentAccount.type}`])}>
                    {userMenuLabelMap[user.currentAccount.type]}
                  </span>
                )}
              </div>

              <Icon component={Triangle} width="0.5rem" height="1rem" className={styles.icon} />
            </button>
          );
        }}
      </ToggleLayer>
    </>
  );
};

export default UserMenu;
